import React, { useState, useEffect } from 'react';
import { listTransactions } from '../../services/adminApi';
import { DollarSign } from 'lucide-react';

const TransactionsTab = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const res = await listTransactions({ limit: 100 });
      setTransactions(res.data.transactions);
      setTotal(res.data.total);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (d) => new Date(d).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' });
  const totalRevenue = transactions.filter(t => t.payment_status === 'paid').reduce((sum, t) => sum + (t.amount || 0), 0);

  if (loading) return <div className="p-8 text-center"><div className="animate-spin rounded-full h-10 w-10 border-4 border-[#009E60] border-t-transparent mx-auto"></div></div>;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-3 gap-3">
        <div className="bg-white border rounded-2xl p-4">
          <div className="text-xs text-gray-500">Total Transactions</div>
          <div className="text-2xl font-bold text-gray-900">{total}</div>
        </div>
        <div className="bg-white border rounded-2xl p-4">
          <div className="text-xs text-gray-500">Paid</div>
          <div className="text-2xl font-bold text-green-600">
            {transactions.filter(t => t.payment_status === 'paid').length}
          </div>
        </div>
        <div className="bg-white border rounded-2xl p-4">
          <div className="text-xs text-gray-500">Revenue (visible)</div>
          <div className="text-2xl font-bold text-[#009E60]">${totalRevenue.toFixed(2)}</div>
        </div>
      </div>

      <div className="bg-white rounded-2xl border overflow-hidden">
        {transactions.length === 0 ? (
          <div className="p-8 text-center text-gray-500">No transactions yet</div>
        ) : (
          <div className="divide-y divide-gray-100">
            {transactions.map((t, i) => (
              <div key={i} className="flex items-center gap-3 p-3">
                <div className="w-10 h-10 rounded-full bg-[#009E60]/10 flex items-center justify-center flex-shrink-0">
                  <DollarSign className="w-5 h-5 text-[#009E60]" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-gray-900 text-sm truncate">
                    {t.package_id} · {t.provider}
                  </div>
                  <div className="text-xs text-gray-500">
                    {formatDate(t.created_at)} · User: {t.user_id?.slice(-8)}
                    {t.promo_code && <span className="ml-2 px-2 py-0.5 bg-[#FFCE00]/20 rounded-full">{t.promo_code}</span>}
                  </div>
                </div>
                <div className="text-right">
                  <div className="font-bold text-gray-900">${(t.amount || 0).toFixed(2)}</div>
                  {t.base_amount && t.base_amount !== t.amount && (
                    <div className="text-xs text-gray-400 line-through">${t.base_amount.toFixed(2)}</div>
                  )}
                  <div className={`text-xs ${t.payment_status === 'paid' ? 'text-green-600' : 'text-gray-500'}`}>
                    {t.payment_status}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TransactionsTab;
